module.exports = __webpack_public_path__ + "static/media/cover.6d7e7639.jpg";